module.exports = __webpack_public_path__ + "img/PR3-F.5dd69e8c.png";